import React from "react";
import {
    Button,
    Typography,
    Grid,
} from "@mui/material";
import CalculateIcon from "@mui/icons-material/Calculate";
import { EuroField } from "./EuroField";


export default function FinancialHistory(props) {

    const fhMinus1 = props.fhMinus1;
    const updateFHMinus1 = props.updateFHMinus1;
    const fhMinus2 = props.fhMinus2;
    const updateFHMinus2 = props.updateFHMinus2;
    const fhMinus3 = props.fhMinus3;
    const updateFHMinus3 = props.updateFHMinus3;
    const fhAvg = props.fhAvg;
    const betrokkene = props.betrokkene;

    const calculateRekendeelMinus1 = props.calculateRekendeelMinus1;
    const calculateRekendeelMinus2 = props.calculateRekendeelMinus2;
    const calculateRekendeelMinus3 = props.calculateRekendeelMinus3;
    const calculateRekendeelAvg = props.calculateRekendeelAvg;

    return (
        <div>
            <Grid container spacing={2}>

                {/* ── Jaar Minus 3 ── */}
                <Grid item xs={3}>
                    <Typography style={{ padding: 10 }}>{betrokkene.jaarMinus3}</Typography><br />
                    <EuroField label="Opbrengsten" name="opbrengsten" value={fhMinus3.opbrengsten} onChange={updateFHMinus3} />
                    <EuroField label="Inkoopkosten" name="inkoopkosten" value={fhMinus3.inkoopkosten} onChange={updateFHMinus3} />
                    <EuroField label="Inhuur derden/Uitbesteed werk" name="inhuur" value={fhMinus3.inhuur} onChange={updateFHMinus3} />
                    <EuroField label="Totale overige bedrijfskosten" name="bedrijfkosten" value={fhMinus3.bedrijfkosten} onChange={updateFHMinus3} />
                    <EuroField label="Kosten vervangende arbeid" name="arbeidKosten" value={fhMinus3.arbeidKosten} onChange={updateFHMinus3} />
                    <EuroField label="Afschrijvingen" name="afscrijvigen" value={fhMinus3.afscrijvigen} onChange={updateFHMinus3} />
                    <EuroField label="Financiele baten en lasten" name="batenenlasten" value={fhMinus3.batenenlasten} onChange={updateFHMinus3} />
                    <EuroField label="Saldo winst-en verliesrekening" name="winst" value={fhMinus3.winst} disabled />
                    <EuroField label="Premies AOV/Pensioen/lijfrente" name="premie" value={fhMinus3.premie} onChange={updateFHMinus3} />
                    <br />
                    <Button
                        variant="outlined"
                        disabled={!fhMinus3.dataChanged}
                        endIcon={<CalculateIcon />}
                        onClick={calculateRekendeelMinus3}
                    >
                        Calculate
                    </Button>
                </Grid>

                {/* ── Jaar Minus 2 ── */}
                <Grid item xs={3}>
                    <Typography style={{ padding: 10 }}>{betrokkene.jaarMinus2}</Typography><br />
                    <EuroField label="Opbrengsten" name="opbrengsten" value={fhMinus2.opbrengsten} onChange={updateFHMinus2} />
                    <EuroField label="Inkoopkosten" name="inkoopkosten" value={fhMinus2.inkoopkosten} onChange={updateFHMinus2} />
                    <EuroField label="Inhuur derden/Uitbesteed werk" name="inhuur" value={fhMinus2.inhuur} onChange={updateFHMinus2} />
                    <EuroField label="Totale overige bedrijfskosten" name="bedrijfkosten" value={fhMinus2.bedrijfkosten} onChange={updateFHMinus2} />
                    <EuroField label="Kosten vervangende arbeid" name="arbeidKosten" value={fhMinus2.arbeidKosten} onChange={updateFHMinus2} />
                    <EuroField label="Afschrijvingen" name="afscrijvigen" value={fhMinus2.afscrijvigen} onChange={updateFHMinus2} />
                    <EuroField label="Financiele baten en lasten" name="batenenlasten" value={fhMinus2.batenenlasten} onChange={updateFHMinus2} />
                    <EuroField label="Saldo winst-en verliesrekening" name="winst" value={fhMinus2.winst} disabled />
                    <EuroField label="Premies AOV/Pensioen/lijfrente" name="premie" value={fhMinus2.premie} onChange={updateFHMinus2} />
                    <br />
                    <Button
                        variant="outlined"
                        disabled={!fhMinus2.dataChanged}
                        endIcon={<CalculateIcon />}
                        onClick={calculateRekendeelMinus2}
                    >
                        Calculate
                    </Button>
                </Grid>

                {/* ── Jaar Minus 1 ── */}
                <Grid item xs={3}>
                    <Typography style={{ padding: 10 }}>{betrokkene.jaarMinus1}</Typography><br />
                    <EuroField label="Opbrengsten" name="opbrengsten" value={fhMinus1.opbrengsten} onChange={updateFHMinus1} />
                    <EuroField label="Inkoopkosten" name="inkoopkosten" value={fhMinus1.inkoopkosten} onChange={updateFHMinus1} />
                    <EuroField label="Inhuur derden/Uitbesteed werk" name="inhuur" value={fhMinus1.inhuur} onChange={updateFHMinus1} />
                    <EuroField label="Totale overige bedrijfskosten" name="bedrijfkosten" value={fhMinus1.bedrijfkosten} onChange={updateFHMinus1} />
                    <EuroField label="Kosten vervangende arbeid" name="arbeidKosten" value={fhMinus1.arbeidKosten} onChange={updateFHMinus1} />
                    <EuroField label="Afschrijvingen" name="afscrijvigen" value={fhMinus1.afscrijvigen} onChange={updateFHMinus1} />
                    <EuroField label="Financiele baten en lasten" name="batenenlasten" value={fhMinus1.batenenlasten} onChange={updateFHMinus1} />
                    <EuroField label="Saldo winst-en verliesrekening" name="winst" value={fhMinus1.winst} disabled />
                    <EuroField label="Premies AOV/Pensioen/lijfrente" name="premie" value={fhMinus1.premie} onChange={updateFHMinus1} />
                    <br />
                    <Button
                        variant="outlined"
                        disabled={!fhMinus1.dataChanged}
                        endIcon={<CalculateIcon />}
                        onClick={calculateRekendeelMinus1}
                    >
                        Calculate
                    </Button>
                </Grid>

                {/* ── Gemiddeld realisatie ── */}
                <Grid item xs={3}>
                    <Typography style={{ padding: 10 }}>Gemiddeld realisatie</Typography><br />
                    <EuroField label="Opbrengsten" name="opbrengsten" value={fhAvg.opbrengsten} disabled />
                    <EuroField label="Inkoopkosten" name="inkoopkosten" value={fhAvg.inkoopkosten} disabled />
                    <EuroField label="Inhuur derden/Uitbesteed werk" name="inhuur" value={fhAvg.inhuur} disabled />
                    <EuroField label="Totale overige bedrijfskosten" name="bedrijfkosten" value={fhAvg.bedrijfkosten} disabled />
                    <EuroField label="Kosten vervangende arbeid" name="arbeidKosten" value={fhAvg.arbeidKosten} disabled />
                    <EuroField label="Afschrijvingen" name="afscrijvigen" value={fhAvg.afscrijvigen} disabled />
                    <EuroField label="Financiele baten en lasten" name="batenenlasten" value={fhAvg.batenenlasten} disabled />
                    <EuroField label="Saldo winst-en verliesrekening" name="winst" value={fhAvg.winst} disabled />
                    <EuroField label="Premies AOV/Pensioen/lijfrente" name="premie" value={fhAvg.premie} disabled />
                    <br />
                    <Button
                        variant="outlined"
                        disabled={!fhAvg.dataChanged}
                        endIcon={<CalculateIcon />}
                        onClick={calculateRekendeelAvg}
                    >
                        Calculate
                    </Button>
                </Grid>

            </Grid>
        </div>
    );
}